import api from '@/services/Api';

class Reviews {
  static create(nominationId, payload) {
    return api.post(`/awards/nomination/${nominationId}/reviews`, payload);
  }

  static all(params) {
    return api.get('/awards/reviews', {
      params,
    });
  }

  static get(id, params) {
    return api.get(`/awards/reviews/${id}`, {
      params,
    });
  }

  static update(id, payload) {
    return api.put(`/awards/reviews/${id}`, payload);
  }

  static declareConflict(id, params) {
    return api.post(`/awards/reviews/${id}/declare-conflict`, params);
  }

  static setAsReviewer(id) {
    return api.post(`/awards/reviews/${id}/set-reviewer`);
  }

  static unsetAsReviewer(id) {
    return api.post(`/awards/reviews/${id}/unset-reviewer`);
  }

  static submit(id, payload) {
    return api.post(`/awards/reviews/${id}/submit`, payload);
  }
}

export default Reviews;
